import React from "react";
import { GuidTextStyled, GuidHeadingStyled, GuidTextWrapperStyled } from "../styles/Styled";
import { i18n } from "../../../services/i18nService";

export const Guid = ({guid}) => {
  return (
    <>
    <GuidTextWrapperStyled>
        <GuidHeadingStyled text={i18n.get("pages.settings.guest.referenceId")} /> <GuidHeadingStyled text={":"} />{" "}
        &nbsp;
        <GuidTextStyled text={guid} />
    </GuidTextWrapperStyled>
    </>
  );
};
